import { cn } from "@/lib/utils";
import {
  CriteriaScore,
  EvaluationCriteria,
} from "@/requests/questionnaries/responses-by-quiz-id.request";
import { FC } from "react";

type EvaluationCriteriaScoreProps = {
  evaluationCriteria: EvaluationCriteria;
  criteriaScore?: CriteriaScore;
  className?: string;
};

const EvaluationCriteriaScore: FC<EvaluationCriteriaScoreProps> = ({
  evaluationCriteria,
  criteriaScore,
  className,
}) => {
  return (
    <div key={evaluationCriteria.id} className={cn(className)}>
      <div className="col-span-3">
        <div className="text-[#333652]">
          {evaluationCriteria.criteriaType.name}&nbsp;
          {criteriaScore && (
            <span className="font-semibold">
              ({criteriaScore.scoreProportion?.toFixed(2)})
            </span>
          )}
        </div>

        <div className="text-xs text-[#8090A3]">
          {evaluationCriteria.criteriaType.description}
        </div>
      </div>

      {criteriaScore ? (
        <div className="mt-1 inline-flex max-w-32 rounded-lg border border-dashed border-[#A0ACBA] p-3 text-sm">
          <span className="grow text-left font-semibold">
            {criteriaScore.score?.toFixed(2)}
          </span>
          <span className="text-[#8090A3]">
            /{criteriaScore.scoreProportion?.toFixed(2)}
          </span>
        </div>
      ) : (
        <div className="mt-1 inline-flex max-w-32 rounded-lg border border-dashed border-[#A0ACBA] p-3 text-sm">
          -
        </div>
      )}
    </div>
  );
};

export default EvaluationCriteriaScore;
